<template lang="html">
  <div class="main">
    <div v-if="ret===-2">{{message.Pl143}} {{space}} ! <a @click="login()">{{message.login}} Cydex</a></div>
    <div v-if="ret===-1">{{message.Pl144}}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: {
        login: this.$lang.ui.form.login,
        Pl143: this.$lang.ui.prompt.l143,
        Pl144: this.$lang.ui.prompt.l144
      },
      ret: '',
      space: '',
      loginFalse: false
    }
  },
  mounted () {
    var query = this.$route.query.token
    this.$http.get('/cydex/api/v1/chk_invite', { params: {
      token: query
    } })
      .then(response => {
        if (response.data.ret === 0) {
          this.$router.push({ path: '/app/accept-new?token=' + query + '&email=' + response.data.invite_info.user_to })
        }
        if (response.data.ret === -1) {
          this.ret = -1
        }
        if (response.data.ret === -2) {
          this.space = response.data.invite_info.project_name
          this.ret = -2
          if (response.data.invite_info.user_info.id !== localStorage.getItem('uid')) {
            this.loginFalse = true
          }
        }
        if (response.data.ret === -3) {
          this.$router.push({ path: '/app/accept?token=' + query })
          if (response.data.invite_info.user_info.id !== localStorage.getItem('uid')) {
            localStorage.setItem('token', '')
          }
        }
      })
  },
  methods: {
    login () {
      if (this.loginFalse) {
        localStorage.setItem('token', '')
      }
      this.$router.push({ path: '/app/login' })
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  margin-top: 120px;
  text-align: center;
  font-size: 18px;
}
a {
  color: #007bc5;
  cursor: pointer;
}
</style>
